import { SubText } from '@procurify/ui'

import { UserAvatar } from '@webapp/components/UserAvatar'
import { type UserLike } from '@webapp/core/interfaces/components/UserLike'
import { GreyCircleStyled } from './styles/GreyCircleStyled'
import { PoolAvatarsStyled } from './styles/PoolAvatarsStyled'

const MAX_DISPLAYED_MEMBERS = 3

export interface IPoolAvatarsProps {
  members: UserLike[]
}

export const PoolAvatars = ({ members }: IPoolAvatarsProps) => {
  const displayedMembers =
    members.length > MAX_DISPLAYED_MEMBERS
      ? members.slice(0, MAX_DISPLAYED_MEMBERS - 1) // Show one less to leave space for the count circle
      : members

  return (
    <PoolAvatarsStyled>
      {displayedMembers.map((member, index) => (
        <UserAvatar
          key={`${member.fullName}-${index}`}
          url={member.profileImage || undefined}
          size='xsmall'
          circular
          shadow
        />
      ))}
      {members.length > MAX_DISPLAYED_MEMBERS && (
        <GreyCircleStyled>
          <SubText>+{members.length - displayedMembers.length}</SubText>
        </GreyCircleStyled>
      )}
    </PoolAvatarsStyled>
  )
}
